<template>
    <div class="agent bg_white">
        <div class="header">
            <button type="create" class="fr" @click="createEvent">新建</button>
        </div>
        <lists ref="lists" :data="lists" :listsStyle="listsStyle" :httpRequestData="httpRequestData"
               @deleteEvent="deleteEvent" @detailEvent="detailEvent" @resetPassword="resetPassword" @editEvent="editEvent" @agentEvent="agentEvent"></lists>
        <detail ref="detail" @updateData="$refs.lists.updateData()"></detail>
    </div>
</template>

<script>
    import Lists from '@/components/Lists'
    import Detail from './detail'
    export default {
        name: "agent",
        components: {
            Lists,Detail
        },
        data() {
            return {
                lists: {
                    title: [{text: '姓名'}, {text: '手机号'}, {text: '身份证号'}, {text: '当前账户余额'}, {text: '类别'}, {text: '抽成比例'}, {text: '提现账户'}, {text: '操作'}]
                },
                listsStyle: [
                    {width: '10%', textAlign: 'left'},
                    {width: '10%', textAlign: 'left'},
                    {width: '15%', textAlign: 'left'},
                    {width: '11%', textAlign: 'center'},
                    {width: '5%', textAlign: 'center'},
                    {width: '8%', textAlign: 'center'},
                    {width: '16%', textAlign: 'left'},
                    {width: '25%', textAlign: 'left'},
                ],
                httpRequestData: {
                    url: '/manage/agent',
                    func: this.httpRequestHandle,
                    error: '获取代理商信息出错',
                    auto: false
                },
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                this.$refs.lists.updateData();
            },
            httpRequestHandle(data) {
                let operation = {
                    arr: [
                        {text: '删除', style: {color: '#FF2118'}, event: 'deleteEvent'},
                        {text: '详情', style: {color: '#1890FF'}, event: 'detailEvent'},
                        {text: '重置密码', style: {color: '#1890FF'}, event: 'resetPassword'},
                        {text: '编辑', style: {color: '#1890FF'}, event: 'editEvent'},
                        {text: '管理', style: {color: '#1890FF'}, event: 'agentEvent'},
                    ]
                };
                return data.map(item =>{
                    return [
                        {text: item.name},
                        {text: item.phone},
                        {text: item.ID},
                        {text: item.balance || 0},
                        {text: this.$config.agentType.get(item.type)},
                        {text: item.commission},
                        {text: item.account},
                        operation
                    ]
                });
            },
            createEvent() {
                this.$refs.detail.init('create');
            },
            detailEvent(data) {
                this.$refs.detail.init('view',data);
            },
            editEvent(data) {
                this.$refs.detail.init('edit',data);
            },
            deleteEvent(data) {
                this.$delete({
                    title: '删除代理商',
                    tooltipContent: '请输入当前代理商名称以删除当前代理商,数据将不可恢复，谨慎操作',
                    value: data.name,
                    confirm: () => {
                        this.$api.delete('/manage/agent/' + data.id).then((data) => {
                            this.$alert.success({content: '删除代理商成功'});
                            this.$refs.lists.updateData();
                        }).catch((error) => {
                            this.$alert.error({content: '删除代理商失败'});
                        });
                    }
                })
            },
            resetPassword(data) {
                this.$api.delete('/manage/agent/rest_password/' + data.id).then((data) => {
                    this.$alert.success({content: '重置密码成功'});
                }).catch((error) => {
                    this.$alert.error({content: '重置密码失败'});
                });
            },
            agentEvent(data) {
                // this.$store.commit('user/setRole','agent');
                this.$api.post('/manage/login',{
                    phone: data.phone,
                    password: data.password
                }).then((res) => {
                    let loginTime = new Date().getTime();
                    this.$store.commit('user/setLogin',{status: true,phone : data.phone,password: data.password,role: this.$config.roleType.get(res.type),
                        token: res.token,loginTime: loginTime});
                    this.$router.push({path: '/'});
                }).catch((error) => {
                    this.$alert.error({content: '登录出错:' + error});
                })
            }
        }
    }
</script>
<!--

-->
<style scoped>
    .agent {
        padding: 0 5px;
    }

    .agent > .header {
        height: 80px;
        padding: 0 15px;
    }

    .agent > .header > button {
        margin-top: 20px;
    }
</style>